(function ($) {
	var selectDrop = function (item) {
		$(item).toggleClass('opened');
	};

	var tabSwitcher = function (item) {
		if (!$(item).hasClass('tabs--link-active')) {
			$('.tabs--tab-links__item').removeClass('tabs--link-active');
			$(item).addClass('tabs--link-active');
			$('.tabs--tab-active').fadeOut(0);
			$('.tabs--tab-active').removeClass('tabs--tab-active');
			var activeTab = $(item).data('tab');
			$('#tab-content-' + activeTab)
				.fadeIn(0)
				.addClass('tabs--tab-active');
			if ($('.tabs__collage__wrapper').parent().hasClass('tabs--tab-active')) {
				//Check Collage Size
				var items = $('.tabs__collage__inner .small--show');
				$.each(items, function (index, item) {
					console.log($(item).width());
					if ($(item).width() == 0) {
						$(item).css({
							'max-height': '400px',
						});
					} else {
						$(item).css({
							'max-height': $(item).width() + 'px',
						});
					}
				});
			}
		}
	};

	var productResizedSlider = function () {
		var docWidth = $(document).width();
		if (
			docWidth <= 640 &&
			!$('.main-product-big-slide__flex-wrapper').hasClass('slick-initialized')
		) {
			//Journal Slider
			$('.main-product-big-slide__flex-wrapper').slick({
				dots: true,
				infinite: true,
				slidesToShow: 1,
			});
		} else if (
			docWidth > 640 &&
			$('.main-product-big-slide__flex-wrapper').hasClass('slick-initialized')
		) {
			$('.main-product-big-slide__flex-wrapper').slick('unslick');
		}

		if (
			docWidth <= 640 &&
			!$('.insta__flex-wrapper').hasClass('slick-initialized')
		) {
			//Insta Slider
			$('.insta__flex-wrapper').slick({
				dots: true,
				infinite: true,
				slidesToShow: 1,
				centerMode: true,
				centerPadding: '50px',
			});
		} else if (
			docWidth > 640 &&
			$('.insta__flex-wrapper').hasClass('slick-initialized')
		) {
			$('.insta__flex-wrapper').slick('unslick');
		}
	};

	var productSliders = function () {
		//Upsell Slider
		if ($('.main-product__upsell-inner').length > 0) {
			$('.main-product__upsell-inner').slick({
				dots: false,
				infinite: false,
				slidesToShow: 2,
				arrows: true,
			});
		}

		if (
			$('.main-product-big-slider').length > 0 &&
			$('.main-product__slider').length > 0
		) {
			//Main product Slider
			$('.main-product__slider').slick({
				dots: false,
				arrows: true,
				infinite: true,
				slidesToShow: 10,
				slidesToScroll: 10,
				focusOnSelect: true,
				responsive: [
					{
						breakpoint: 980,
						settings: {
							slidesToShow: 6,
							slidesToScroll: 6,
						},
					},
					{
						breakpoint: 640,
						settings: {
							slidesToScroll: 8,
							slidesToShow: 8,
						},
					},
				],
			});

			var $slider = $('.main-product-big-slider');
			var videoIdx = $slider.find('.main-product-big-slide__flex-column video').eq(0).parents('.main-product-big-slide__flex-column').index();

			var $slick = $('.main-product-big-slider')
			.slick({
				dots: false,
				arrows: false,
				fade: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				draggable: false,
				swipe: false,
				swipeToSlide: false,
				touchMove: false,
				accessibility: false,
				speed: 500,
			});

			$('.slider-video-play').on('click', function(event) {

				$slick.find('.main-product-big-slide__flex-wrapper').slick('slickGoTo', parseInt(videoIdx));

				event.preventDefault();
			});
		}
	};

	//Add to bundle click function
	$(document).on('click', '.main-product__bundle-wrapper .btn', function () {
		$(this).addClass('bundle-added');
		$(this).html(`
      <svg class="svg">
         <use xlink:href="#check"></use>
      </svg> ${$(this).data('added')}`);

		setTimeout(function () {
			$('.background-overlay').toggleClass('bg-activated');
			setTimeout(function () {
				$(this).toggleClass('cart-opened');
				$('.mini-cart').toggleClass('opened');
			}, 200);
			$.scrollLock();
		}, 500);
	});

	$(document).on('click', '.select__dropdown p', function () {
		selectDrop($(this).parent());
	});

	$(document).on('click', '.rates__sort__inner p', function () {
		selectDrop($(this).parent());
	});

	$(document).on('click', '.select__dropdown li', function () {
		$('.select__dropdown').find('p').html($(this).text());
		$('.select__dropdown').toggleClass('opened');
	});

	$(document).on('click', '.rates__sort__inner li', function () {
		$('.rates__sort__inner').find('p').html($(this).text());
		$('.rates__sort__inner').toggleClass('opened');
	});

	$(document).on(
		'click',
		'.main-product__accordion-item h2,.main-product__accordion-item .plus-svg,.main-product__accordion-item .minus-svg',
		function () {
			$(this).parent().toggleClass('opened');
			$(this).parent().find('.plus-svg').fadeToggle(100);
			$(this).parent().find('.minus-svg').fadeToggle(100);
			$(this).parent().find('> ul, > .content').slideToggle(300);
		}
	);
	$(document).on(
		'click',
		'.tabs__compare__accordion-item h2,.tabs__compare__accordion-item .plus-svg,.tabs__compare__accordion-item .minus-svg',
		function () {
			$(this).parent().toggleClass('opened');
			$(this).parent().find('.plus-svg').fadeToggle(100);
			$(this).parent().find('.minus-svg').fadeToggle(100);
			$(this).parent().find('> ul, > .content').slideToggle(300);
		}
	);

	$(document).ready(function () {
		productSliders();
		$('.tooltip').tooltipster({
			side: 'bottom',
			trigger: 'ontouchstart' in window ? 'click' : 'hover',
		});

		$(document).on('click', '.tabs--tab-links__item', function () {
			tabSwitcher($(this));
		});
	});
	$(window).on('load', function(){
		productResizedSlider();
	});

	$(window).resize(function () {
		productResizedSlider();
	});
})(jQuery);
